import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
    changed: false,
    data: '',
    newData: '',
};

export const actionTypes = {
    UpdateRecord: "[UPDATE_RECORD] Action",
    ResetRecord: "[RESET_RECORD] Action",
};

export const reducer = persistReducer(
    { storage, key: "Record" },
    (state = initialState, action) => {
        
        const { type, payload } = action;

        switch (type) {
        case actionTypes.UpdateRecord: 
            return payload;
        case actionTypes.ResetRecord: 
            return initialState;
        default:
            return state;
      }
    }
);

export const actions = {
    updateRecord: payload => ({ type: actionTypes.UpdateRecord, payload:  payload }),
    resetRecord: payload => ({ type: actionTypes.ResetRecord, payload:  payload })
};
  